module.exports = __webpack_public_path__ + "img/bg-image-mobile.8e034bb6.svg";